export default class UrlExecutor
{

  static execute(url)
  {

    try{
      let jsonResult = JSON.parse(url);
      if (typeof jsonResult === 'object') {
        new ActionList().createFromElement(jsonResult).run();
        return;
      }
    }
    catch(e) { /* Clearly not a json string */ }

    if (!url) {
      console.warn('no url defined');
      return;
    }

    // allowed protocols:
    // - http://
    // - https://
    // - //
    // - javascript:

    // remove spaces
    url = url.replace(/^\s+|\s+$/g, '');

    let lCaseUrl = url.toLowerCase();

    // check for http / https
    if (lCaseUrl.indexOf('http://') === 0 || lCaseUrl.indexOf('https://') === 0 || lCaseUrl.indexOf('//') === 0) {
      document.location.href = url;
      return;
    }

    // check for javascript
    if (lCaseUrl.indexOf('javascript:') === 0) {
      UrlExecutor.executeJavascript(url.replace(/javascript:/i, ''));
      return;
    }

    if (url.indexOf('/') === 0) {
      document.location.href = url;
      return;
    }

    alert('invalid link: "' + url + '"');

  }

  static executeJavascript(code)
  {

    // List of allowed functions. Keep empty to disable whitelisting!
    const whitelist = [];

    // find function calls
    // regexp:
    //  ^\s*    :   String may start with 0 or more spaces
    //  ([^(]+) :   Match 1 or more characters other than '(', and STORE
    //  \s*     :   Allow 0 or more spaces
    //  \(      :   Look for '('
    //
    //  (.+)    :   Look for anything between '(' and ')' as greedy as possible,
    //                meaning that we allow ')' to be selected if followed
    //                by ')', and STORE
    //
    //  \)      :   Look for ')'
    //  \s*     :   Allow 0 or more spaces
    //  ;?      :   Allow semicolon, but ignore if not present
    //  \s*     :   Allow 0 or more spaces
    //
    //  $       :   match end of string, meaning that nothing may follow after
    //                our semicolon except spaces

    let matches = code.match(/^\s*([^(]+)\s*\((.+)\)\s*;?\s*$/);

    if (!matches) {
      throw 'No function call or multiple function calls in javascript-link: "' + code + '"';
    }


    let fn = matches[1];
    let par = matches[2];

    if (par.match(/\(/)) {
      throw 'Cannot call more than one function in a javascript link: "' + code + '"';
    }

    if (fn === 'eval' || fn.replace(/\s+/g, '') === 'eval.apply') {
      throw 'Cannot call eval in a javascript link: "' + code + '"';
    }

    if (whitelist.length === 0 || whitelist.includes(fn)) {
      eval(code);
    }


  }

}
